export enum Features {
  GAS_ELECTRICITY = 'gas-electricity',
  ACCOUNTING = 'accounting',
  GDV = 'gdv',
  REPORTS = 'reports'
}
